/**
 * Utility function for merging Tailwind CSS classes
 *
 * Uses clsx for conditional classes and tailwind-merge to resolve conflicts
 */

import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind CSS classes intelligently
 * - Resolves conflicts (e.g., 'px-4 p-2' → 'p-2')
 * - Handles conditional classes
 * - Removes duplicates
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
